import React, { useEffect, useState } from 'react';
import { apiGet, apiPost } from '../../../lib/api';
import { toast } from 'sonner';
import { Boxes, CheckCircle2 } from 'lucide-react';
import { formatDate } from '../../../lib/format';

export default function MyAssets() {
  const [data, setData] = useState(null);
  const load = () => apiGet('/hr/me/assets').then(setData).catch(() => setData({ linked: false, active: [], returned: [] }));
  useEffect(() => { load(); }, []);
  if (!data) return <div className="p-8 text-slate-500">Loading…</div>;

  const ack = async (al) => {
    try { await apiPost(`/hr/assets/allocations/${al.id}/acknowledge`, {}); toast.success('Receipt acknowledged'); load(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div className="space-y-5 p-6 md:p-8 max-w-3xl" data-testid="my-assets-page">
      <div>
        <div className="text-[10px] font-display font-bold uppercase tracking-[0.2em] text-[#3b4872] mb-2">My Workspace</div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">My Assets</h1>
        <p className="text-sm text-slate-600 mt-1">Company assets currently in your custody.</p>
      </div>

      {data.linked === false && <div className="bg-amber-50 border border-amber-200 rounded-sm p-4 text-sm text-amber-800" data-testid="no-emp">No employee record linked to your login yet.</div>}

      <div className="bg-white border border-slate-200 rounded-sm">
        <div className="px-4 py-3 border-b"><h3 className="text-xs font-display font-bold uppercase tracking-wider text-slate-500 flex items-center gap-2"><Boxes size={14} /> In My Custody ({(data.active || []).length})</h3></div>
        {(data.active || []).length === 0 ? <div className="p-4 text-xs text-slate-400">No assets allocated to you.</div> : (
          <div className="divide-y divide-slate-100">
            {data.active.map((al) => (
              <div key={al.id} className="p-4 flex items-center justify-between gap-2" data-testid={`my-asset-${al.id}`}>
                <div>
                  <div className="font-display font-bold text-sm">{al.asset_name} <span className="text-slate-400 text-xs font-mono">{al.asset_tag}</span></div>
                  <div className="text-[11px] text-slate-500">Allocated {formatDate(al.allocated_at)}{al.expected_return_date ? ` · return by ${al.expected_return_date}` : ''}</div>
                </div>
                {al.acknowledgement ? <span className="text-[10px] text-emerald-700 font-bold uppercase flex items-center gap-1"><CheckCircle2 size={12} /> Acknowledged</span>
                  : <button onClick={() => ack(al)} data-testid={`ack-${al.id}`} className="text-xs text-[#3b4872] font-bold">Acknowledge receipt</button>}
              </div>
            ))}
          </div>
        )}
      </div>

      {(data.returned || []).length > 0 && (
        <details className="bg-white border border-slate-200 rounded-sm">
          <summary className="px-4 py-2.5 cursor-pointer text-xs font-display font-bold uppercase tracking-wider text-slate-500">Returned ({data.returned.length})</summary>
          <div className="px-4 pb-3 divide-y divide-slate-100">
            {data.returned.map((al) => (
              <div key={al.id} className="py-2 text-xs flex items-center justify-between"><span>{al.asset_name} <span className="text-slate-400">{al.asset_tag}</span></span><span className="text-slate-400">returned {formatDate(al.returned_at)}</span></div>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}
